export default "__VITE_ASSET__DyI7lvz4__"